var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.567,
    height: 73.51,
    viewBox: "0 0 64.567 73.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10155",
    "data-name": "Grupo 10155",
    transform: "translate(-3372.01 -3120.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6924",
    "data-name": "Trazado 6924",
    d: "M161.967,17.526,151.311,6.943a.846.846,0,0,0-.6-.224h-39.5a.906.906,0,0,0-.894.894V71.257a.906.906,0,0,0,.894.894h29.064a.894.894,0,1,0,0-1.788h-28.17V8.434H149.82V19.091h10.657V45.472a.906.906,0,0,0,.894.894.861.861,0,0,0,.894-.894V18.2a2.654,2.654,0,0,0-.3-.671Zm-10.359-7.9,7.676,7.676h-7.676Z",
    transform: "translate(3262.038 3113.785)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6925",
    "data-name": "Trazado 6925",
    d: "M370.69,349.94a15.65,15.65,0,1,1,15.65-15.65A15.648,15.648,0,0,1,370.69,349.94Zm0-29.586a13.936,13.936,0,1,0,13.936,13.936A13.962,13.962,0,0,0,370.69,320.354Z",
    transform: "translate(3049.887 2843.374)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6926",
    "data-name": "Trazado 6926",
    d: "M202.465,140.111h-35.25a.894.894,0,0,1,0-1.788h35.25a.894.894,0,0,1,0,1.788Z",
    transform: "translate(3213.491 2999.696)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6927",
    "data-name": "Trazado 6927",
    d: "M202.465,238.671h-35.25a.906.906,0,0,1-.894-.894.861.861,0,0,1,.894-.894h35.25a.894.894,0,0,1,0,1.788Z",
    transform: "translate(3213.491 2914.252)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6928",
    "data-name": "Trazado 6928",
    d: "M202.465,287.951h-35.25a.906.906,0,0,1-.894-.894.861.861,0,0,1,.894-.894h35.25a.894.894,0,0,1,0,1.788Z",
    transform: "translate(3213.491 2871.53)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6929",
    "data-name": "Trazado 6929",
    d: "M202.465,189.391h-35.25a.906.906,0,0,1-.894-.894.861.861,0,0,1,.894-.894h35.25a.894.894,0,0,1,0,1.788Z",
    transform: "translate(3213.491 2956.974)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6930",
    "data-name": "Trazado 6930",
    d: "M191.51,337.231H167.215a.894.894,0,1,1,0-1.788H191.51a.906.906,0,0,1,.894.894A.861.861,0,0,1,191.51,337.231Z",
    transform: "translate(3213.491 2828.808)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6931",
    "data-name": "Trazado 6931",
    d: "M184.8,386.507H167.215a.894.894,0,0,1,0-1.788H184.8a.906.906,0,0,1,.894.894A.861.861,0,0,1,184.8,386.507Z",
    transform: "translate(3213.491 2786.089)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6932",
    "data-name": "Trazado 6932",
    d: "M449,396.992a.857.857,0,0,0-1.267,0l-2.087,2.087v-8.421a.861.861,0,0,0-.894-.894.8.8,0,0,0-.82.894v8.421l-2.087-2.087a.9.9,0,0,0-1.267,1.267l3.577,3.577a.907.907,0,0,0,1.193,0l3.577-3.577a.81.81,0,0,0,.074-1.267Z",
    transform: "translate(2975.972 2781.715)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.400b59a3d6a3fda1414c10939179bf9b.svg";
export { ForwardRef as ReactComponent };